import { ref, computed, onMounted, onBeforeUnmount } from 'vue';

type Params<T> = {
  computeFn: (currentTime: number) => T;
  updateInterval?: number;
};

export function useIntervalCompute<T>(params: Params<T>) {
  const { computeFn, updateInterval = 10000 } = params;
  const currentTime = ref(Date.now());
  let intervalId: NodeJS.Timeout | null = null;

  const computedValue = computed(() => computeFn(currentTime.value));

  const forceUpdate = () => {
    currentTime.value = Date.now();
  };

  onMounted(() => {
    intervalId = setInterval(() => {
      currentTime.value = Date.now();
    }, updateInterval);
  });

  onBeforeUnmount(() => {
    if (intervalId) {
      clearInterval(intervalId);
    }
  });

  return {
    computedValue,
    forceUpdate,
  };
}
